"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const StyledH1 = styled_components_1.default.h1 `
  @import url("https://doc.rota.com/font.css");
  font-family: "Gotham A", "Gotham B";
  font-weight: 300;
  font-size: 96px;
  line-height: 115px;
  letter-spacing: -1.5px;
  color: ${({ color, theme }) => (color ? color : theme.text.primary)};
  opacity: ${({ color }) => (color ? 1 : 0.87)};
`;
const StyledH2 = styled_components_1.default.h2 `
  @import url("https://doc.rota.com/font.css");
  font-family: "Gotham A", "Gotham B";
  font-weight: 300;
  font-size: 60px;
  line-height: 72px;
  color: ${({ color, theme }) => (color ? color : theme.text.primary)};
  opacity: ${({ color }) => (color ? 1 : 0.87)};
`;
const StyledH3 = styled_components_1.default.h3 `
  @import url("https://doc.rota.com/font.css");
  font-family: "Gotham A", "Gotham B";
  font-weight: 400;
  font-size: 48px;
  line-height: 58px;
  color: ${({ color, theme }) => (color ? color : theme.text.primary)};
  opacity: ${({ color }) => (color ? 1 : 0.87)};
`;
const StyledH4 = styled_components_1.default.h4 `
  @import url("https://doc.rota.com/font.css");
  font-family: "Gotham A", "Gotham B";
  font-weight: 400;
  font-size: 34px;
  line-height: 41px;
  letter-spacing: 0.25px;
  color: ${({ color, theme }) => (color ? color : theme.text.primary)};
  opacity: ${({ color }) => (color ? 1 : 0.87)};
`;
const StyledH5 = styled_components_1.default.h5 `
  @import url("https://doc.rota.com/font.css");
  font-family: "Gotham A", "Gotham B";
  font-weight: 400;
  font-size: 24px;
  line-height: 28.8px;
  color: ${({ color, theme }) => (color ? color : theme.text.primary)};
  opacity: ${({ color }) => (color ? 1 : 0.87)};
`;
const StyledH6 = styled_components_1.default.h6 `
  @import url("https://doc.rota.com/font.css");
  font-family: "Gotham A", "Gotham B";
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.15px;
  color: ${({ color, theme }) => (color ? color : theme.text.primary)};
  opacity: ${({ color }) => (color ? 1 : 0.87)};
`;
const StyledH7 = styled_components_1.default.p `
  @import url("https://doc.rota.com/font.css");
  font-family: "Gotham A", "Gotham B";
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.15px;
  color: ${({ color, theme }) => (color ? color : theme.text.primary)};
  opacity: ${({ color }) => (color ? 1 : 0.87)};
`;
const StyledNormalText = styled_components_1.default.p `
  @import url("https://doc.rota.com/font.css");
  font-family: "Gotham A", "Gotham B";
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.44px;
  color: ${({ color, theme }) => (color ? color : theme.text.primary)};
  opacity: ${({ color }) => (color ? 1 : 0.87)};
`;
const StyledSmallText = styled_components_1.default.p `
  @import url("https://doc.rota.com/font.css");
  font-family: "Gotham A", "Gotham B";
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: ${({ color, theme }) => (color ? color : theme.text.primary)};
  opacity: ${({ color }) => (color ? 1 : 0.87)};
`;
const StyledSubtitle = styled_components_1.default.p `
  @import url("https://doc.rota.com/font.css");
  font-family: "Gotham A", "Gotham B";
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.1px;
  color: ${({ color, theme }) => (color ? color : theme.text.primary)};
  opacity: ${({ color }) => (color ? 1 : 0.87)};
`;
const StyledButton = styled_components_1.default.p `
  @import url("https://doc.rota.com/font.css");
  font-family: "Gotham A", "Gotham B";
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.1px;
  color: ${({ color, theme }) => (color ? color : theme.text.primary)};
  opacity: ${({ color }) => (color ? 1 : 0.87)};
`;
const StyledOverline = styled_components_1.default.p `
  @import url("https://doc.rota.com/font.css");
  font-family: "Gotham A", "Gotham B";
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${({ color, theme }) => (color ? color : theme.text.primary)};
  opacity: ${({ color }) => (color ? 1 : 0.87)};
`;
const StyledCaption = styled_components_1.default.p `
  @import url("https://doc.rota.com/font.css");
  font-family: "Gotham A", "Gotham B";
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: ${({ color, theme }) => (color ? color : theme.text.primary)};
  opacity: ${({ color }) => (color ? 1 : 0.87)};
`;
const typography = {
    StyledH1,
    StyledH2,
    StyledH3,
    StyledH4,
    StyledH5,
    StyledH6,
    StyledH7,
    StyledNormalText,
    StyledSmallText,
    StyledSubtitle,
    StyledButton,
    StyledOverline,
    StyledCaption
};
exports.default = typography;
